import { ProductGroup } from "./_context";

export const ProductGroupProvider = ProductGroup.Provider